import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatPaginatorModule,
  MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule,
  MatDialogModule, MatGridListModule, MatIconModule, MatInputModule,
  MatListModule, MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule,
  MatRadioModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSortModule,
  MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatToolbarModule,
  MatTooltipModule, MatFormFieldModule, MatExpansionModule, MatStepperModule
} from '@angular/material';

// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SignaturePadModule } from 'angular2-signaturepad';


import { FlexLayoutModule } from '@angular/flex-layout';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { TourNgBootstrapModule } from 'ngx-tour-ng-bootstrap';
import { TranslateModule } from 'ng2-translate/ng2-translate';
import { Ng5BreadcrumbModule } from 'ng5-breadcrumb';
import { Ng2PageScrollModule} from 'ng2-page-scroll';

// import { ToastrModule } from 'ngx-toastr';
// import { LoadingBarHttpModule } from '@ngx-loading-bar/http';
import { SnackbarModule } from 'ngx-snackbar';
// import { LoadingBarModule } from 'ngx-loading-bar';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// import { SharedDataService} from '../../shared-data.service';
// import { AuthenticationService } from './authentication.service';
// import { AuthGuard } from './auth.guard';
// import { PageTitleService } from './core/page-title/page-title.service';
import { NgxLoadingModule } from 'ngx-loading';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {UserIdMappingPipe} from "../../user-id-mapping.pipe";

@NgModule({
  imports: [ 
    NgCircleProgressModule.forRoot({
    radius: 100,
    percent: 60,
    outerStrokeWidth: 16,
    innerStrokeWidth: 8,
    outerStrokeColor: "#78C000",
    innerStrokeColor: "#C7E596",
    animationDuration: 300
  })
],
  declarations: [UserIdMappingPipe],
  exports: [
    MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatPaginatorModule, NgbModule, SignaturePadModule,
    MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule, NgbModalModule, Ng5BreadcrumbModule,
    MatDialogModule, MatGridListModule, MatIconModule, MatInputModule, FormsModule, ReactiveFormsModule, CdkTableModule,
    MatListModule, MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, SnackbarModule, HttpClientModule,
    MatRadioModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSortModule, ChartsModule, FlexLayoutModule,
    MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatToolbarModule, Ng2PageScrollModule,
    MatTooltipModule, MatFormFieldModule, MatExpansionModule, MatStepperModule, CommonModule,
    TranslateModule, TourNgBootstrapModule, AgmCoreModule, LoadingBarHttpClientModule,   NgxLoadingModule,UserIdMappingPipe

    //New List
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/shared-module/shared/shared.module.ts